import { SearchOutlined } from "@ant-design/icons";
import { useState, useMemo } from "react";
import "./SearchBar.css";

function SearchBar({
  projects = [],
  onProjectSelect,
}) {
  const [query, setQuery] =
    useState("");

  const [showDropdown, setShowDropdown] =
    useState(false);

  const suggestions =
    useMemo(() => {
      if (!query.trim()) return [];

      return projects
        .filter((project) =>
          [
            project.name,
            project.zone,
            project.district,
            project.village,
            project.voltage,
          ]
            .join(" ")
            .toLowerCase()
            .includes(
              query.toLowerCase()
            )
        )
        .slice(0, 8);
    }, [query, projects]);

    const handleSelect = (project) => {
    onProjectSelect(project);
    setQuery("");
    setShowDropdown(false);
    };

  return (
    <div className="search-wrapper">
      <div className="search-section">
        <input
          value={query}
          onChange={(e) =>
            setQuery(
              e.target.value
            )
          }
          onFocus={() =>
            setShowDropdown(true)
          }
          placeholder="Search Projects"
        />

        <SearchOutlined />
      </div>

      {showDropdown &&
        suggestions.length >
          0 && (
          <div className="search-dropdown">
            {suggestions.map(
              (project) => (
                <div
                  key={project.id}
                  className="search-item"
                  onClick={() =>
                    handleSelect(
                      project
                    )
                  }
                >
                  <strong>
                    {
                      project.name
                    }
                  </strong>

                  <small>
                    {
                      project.zone
                    }{" "}
                    •{" "}
                    {
                      project.district
                    }
                  </small>
                </div>
              )
            )}
          </div>
        )}
    </div>
  );
}

export default SearchBar;